export default __webpack_public_path__ + "maps-examples-shape-collection-1200-fb545698662f5c23acbc77bcdc37c890.webp";